import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { MotionConfig } from 'framer-motion'
import './index.css'
import App from './App.tsx'
import { BrowserRouter } from 'react-router'
import { Provider } from 'react-redux'
import store from './store/store.ts'
import ResponsiveWrapper from './components/common/responsiveWapper.tsx'
import ErrorFallback from './components/common/errorFallback.tsx'
import { initSentry } from './config/sentry.ts'

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <MotionConfig reducedMotion="user">
          <ResponsiveWrapper>
            <Sentry.ErrorBoundary
              fallback={({ error, resetError }) => (
                <ErrorFallback error={error} resetError={resetError} />
              )}
            >
              <App />
            </Sentry.ErrorBoundary>
          </ResponsiveWrapper>
        </MotionConfig>
      </Provider>
    </BrowserRouter>
  </StrictMode>,
)
